<template>
  <!--linear-card-->
  <div class="card" :style="{ minHeight: height + 'px', width: width + '%'}">
    <card-title
      style="padding-bottom: 0 !important;"
      class="p-t-8"
      :class="{ 'p-x-12': isRowPadding }"
      :type="type"
      :title="title"
      :font-size="fontSize"
      :is-more="isMore"
      :copy-title="copyTitle"
      :commodity-arr="commodityArr"
      :linear-top-color="linearTopColor"
      :linear-bottom-color="linearBottomColor"
    >
    </card-title>
    <slot></slot>
  </div>
</template>

<script>
import cardTitle from '@/components/cardTitle'
export default {
  components: {
    cardTitle
  },
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    title: {
      type: String
    },
    type: {
      type: String
    },
    commodityArr: {
      type: Array
    },
    isMore: {
      type: Boolean,
      default: false
    },
    linearTopColor: {
      type: String,
      default: 'rgba(255, 218, 205, 1)'
    },
    linearBottomColor: {
      type: String,
      default: 'rgba(255,255,255,0)'
    },
    fontSize: {
      type: Number,
      default: 16
    },
    copyTitle: {
      type: String,
      default: ''
    },
    isRowPadding: {
      type: Boolean,
      default: true
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
  .card {
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
  }
</style>
